import { defineStore } from 'pinia'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    access_token: '',
    usuario: ''
  }),
  actions: {
    async setToken(token) {
      this.access_token = token

      const result = await api.get('/auth', {
          headers: {
            Authorization: `Bearer ${this.access_token}`
          }
      })
      this.usuario = result.data

    },
    longout() {
      this.access_token = ''
    }
  },
  persist: true
})